import React from 'react';
import { useSafeContext } from '../hooks/use-safe-context';
import { CategoryModels } from '../types/model';

export const ModelsConfigContext = React.createContext<
  undefined | CategoryModels[]
>(undefined);

export function useModelsConfig(): CategoryModels[] {
  return useSafeContext(ModelsConfigContext, 'ModelsConfig');
}
